import { createApiRequest } from '@/utils/services';

const fetchInteraction = (interactionId) => {
  // eslint-disable-next-line
  console.warn('fetchInteraction to be implemented', interactionId);

  return {};
};

const submitInteraction = ({ data, interactionId }) =>
  createApiRequest({
    method: interactionId ? 'put' : 'post',
    path: interactionId ? `interactions/${interactionId}` : 'interactions',
    data,
    throwErrors: true,
  });

export const interactionsService = {
  fetchInteraction,
  submitInteraction,
};
